import {
    getParentByClass,
    addClass,
    removeClass,
} from "./../helper/helper";

/**
 * Init input effects and js-animations
 */
export default function initInputEffects() {
    // select all labels
    const labels = document.getElementsByTagName("label");

    // Update on init (if value ist initial set)
    for (let i = 0; i < labels.length; i++) {
        (function (x) {
            if (labels[x].htmlFor !== "") {
                // select input
                let input = document.getElementById(labels[x].htmlFor);
                if (input) {
                    // update label if input has value
                    if (input.value) {
                        let container = getInputGroupContainer(input);
                        addClass(container, "input-has-focus");
                    }
                }
            }
        })(i);
    }

    document.addEventListener("input", function (event) {
        let input = document.activeElement;

        if (
            input.type === "text" ||
            input.type === "number" ||
            input.type === "tel" ||
            input.type === "email" ||
            input.type === "password" ||
            input.type === "select" ||
            input.type === "textarea" ||
            input.type === "select-one"
        ) {
            let container = getInputGroupContainer(input);
            addClass(container, "input-has-focus");
        }
    });

    document.addEventListener("focusin", function (event) {
        let input = document.activeElement;

        if (
            input.type === "text" ||
            input.type === "number" ||
            input.type === "tel" ||
            input.type === "email" ||
            input.type === "password" ||
            input.type === "select" ||
            input.type === "textarea" ||
            input.type === "select-one"
        ) {
            let container = getInputGroupContainer(input);
            addClass(container, "input-has-focus");

            input.addEventListener(
                "focusout",
                function (event) {
                    if (!input.value) {
                        removeClass(container, "input-has-focus");
                    }
                },
                false
            );
        }
    });

    /**
     * Change listener for inputs (including autocomplete)
     * no default listener
     * only works with helper ("js/initHelper/initInputEffects.js")
     */
    let allInputs = document.querySelectorAll("input");

    for (let i = 0; i < allInputs.length; i++) {
        allInputs[i].addEventListener("change", function (event) {
            let container = getInputGroupContainer(allInputs[i]);
            if (container) {
                addClass(container, "input-has-focus");
            }
        });
    }

    // Change handler for Checkbox
    // document.addEventListener("click", function (event) {
    //   let target = event.target;
    //   let container = getParentByClass(target, "styled-checkbox");

    //   if (container) {
    //     const input = container.querySelector('input[type="hidden"]').value;
    //     const value = input ? input.value : 'false';

    //     if (value == 'true') {
    //       addClass(container, "input-has-focus");
    //     } else {
    //       removeClass(container, "input-has-focus");
    //     }

    //   }
    // });
}

/**
 * Get input group container to toggle class
 * considered multiple framework notations
 * @param {dom} input
 */
function getInputGroupContainer(input) {
    return getParentByClass(input, "styled-input")
        ? // if (custom styling class)
        getParentByClass(input, "styled-input")
        : // else if (bootstrap)
        getParentByClass(input, "form-group")
            ? getParentByClass(input, "form-group")
            : // : // else if (dev extremm)
              // getParentByClass(input, "dx-field-item")
              // ? getParentByClass(input, "dx-field-item")
              // else null
            null;
}
